import { render, staticRenderFns } from "./Page-GeneralUser.vue?vue&type=template&id=6847c56b&"
import script from "./Page-GeneralUser.vue?vue&type=script&lang=js&"
export * from "./Page-GeneralUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports